import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContactDirectoryService {
  baseUrl: string = environment.baseUrl;

  constructor(private http: HttpClient) {}

  getMasterData(
    page: number = 1,
    limit: number = 10,
    search?: string,
    columnFilters?: string[],
    startDate?: string,
    endDate?: string,
    sortField?: string,
    sortOrder?: string,
  ): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());

    if (search && search.trim()) {
      params = params.set('search', search.trim());
    }

    if (columnFilters && columnFilters.length > 0) {
      columnFilters.forEach((filter) => {
        params = params.append('column_filters', filter);
      });
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    if (sortField) {
      params = params.set('sort_field', sortField);
    }

    if (sortOrder) {
      params = params.set('sort_order', sortOrder);
    }

    return this.http.get(`${this.baseUrl}/bounty/user/list-master-data`, {
      params,
    });
  }

  submitEntry(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/bounty/submit-entries`, payload);
  }

  /** Submit single entry with optional contributor image (multipart/form-data). */
  submitEntryFormData(formData: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/bounty/submit-entries`, formData);
  }

  getContributions(
    limit: number = 10,
    offset: number = 0,
    status?: string,
    startDate?: string,
    endDate?: string,
  ): Observable<any> {
    let params = new HttpParams()
      .set('limit', limit.toString())
      .set('offset', offset.toString());

    if (status) {
      params = params.set('status', status);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    return this.http.get(`${this.baseUrl}/bounty/contributions`, { params });
  }

  getMyUpdateRequests(
    limit: number = 20,
    offset: number = 0,
    status?: string,
  ): Observable<any> {
    let params = new HttpParams()
      .set('limit', limit.toString())
      .set('offset', offset.toString());

    if (status) {
      params = params.set('status', status);
    }

    return this.http.get(`${this.baseUrl}/bounty/my-update-requests`, { params });
  }

  deleteMyUpdateRequest(updateRequestId: string): Observable<any> {
    return this.http.delete(
      `${this.baseUrl}/bounty/my-update-requests/${updateRequestId}`,
    );
  }

  getLeaderboard(): Observable<any> {
    return this.http.get(`${this.baseUrl}/bounty/admin/get-leader`);
  }

  getOperatorTypes(): Observable<any> {
    return this.http.get(`${this.baseUrl}/bounty/operator-types`);
  }

  requestDeletion(payload: {
    submission_ids: string[];
    request_reason: string;
  }): Observable<any> {
    return this.http.post(`${this.baseUrl}/bounty/request-deletion`, payload);
  }

  requestUpdate(payload: {
    submission_id: string;
    updated_row_data: {
      address: string;
      email: string;
      friendly_name: string;
      name: string;
      operator: string;
      operator_type: string;
      phone: string;
    };
    request_reason: string;
  }): Observable<any> {
    return this.http.post(`${this.baseUrl}/bounty/request-update`, payload);
  }

  requestUpdateFormData(formData: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/bounty/request-update`, formData);
  }
}
